module.exports = __webpack_public_path__ + "img/7.85eaa737.png";